import img1 from '../images/box-item/connect-1.png';
import img2 from '../images/box-item/connect-2.png';
import img3 from '../images/box-item/connect-3.png';
import img4 from '../images/box-item/connect-4.png';
import img5 from '../images/box-item/connect-5.png';
import img6 from '../images/box-item/connect-6.png';
import img7 from '../images/box-item/connect-7.png';

const data = [
    {
        id: 1,
        img: img1,
        title : 'B2C Corporates',
        desc : 'Empowering consumer brands with personalized PR strategies that resonate with individual customer preferences.',
        link : '/dt-tuning/b2c',
    },
    {
        id: 2,
        img: img2,
        title : 'B2B Corporates',
        desc : 'Enhancing business relationships through targeted PR campaigns that align with industry-specific needs.',
        link : '/business-type',
    },
    {
        id: 3,
        img: img3,
        title : 'B2G Corporates',
        desc : 'Streamlining public sector engagement by delivering data-driven PR insights tailored to governmental audiences.',
        link : '/business-type',
    },
    {
        id: 4,
        img: img4,
        title : 'B2B2C Corporates',
        desc : 'Bridging businesses and end consumers with customized PR that drive brand loyalty and influence across the value chain.',
        link : '/business-type',
    },
]

export default data;